export default function RegStrip({ rows }) {
  const def = rows || [
    ["Legal entity",         "Daksfirst Limited"],
    ["UK company number",    "11626401"],
    ["Principal · FCA FRN",  "Maystone Capital Ltd · 758412"],
    ["AR registration",      "937220"]
  ];
  return (
    <section className="reg tight">
      <div className="wrap">
        {def.map(([label, val]) => (
          <div className="cell" key={label}>
            <div className="label">{label}</div>
            <div className="val">{val}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
